'use strict';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FaturaService } from '../shared/fatura.service';
import { FaturamentoLog } from '../shared/faturamentoLog.model';
import { InfoDialogComponent } from '../../core/dialogs/info-dialog/info-dialog.component';

export interface DialogData {
  faturaId: number;
}

@Component({
  selector: 'FaturamentoLogComponent',
  templateUrl: 'faturamento-log.component.html',
  styleUrls: ['faturamento-log.component.css']
})
export class FaturamentoLogComponent implements OnInit {

  logs: FaturamentoLog[] = [];
  faturaId: number;
  maximizado: boolean = false;

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<FaturamentoLogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private faturaService: FaturaService
  ) {
    this.faturaId = data.faturaId;
  }

  ngOnInit(): void {
    this.carregarLogs();
    this.restaurarDialog();
  }

  carregarLogs(): void {
    this.faturaService.listaLog(this.faturaId).subscribe(
      (data) => {
        this.logs = data.body;
      },
      (error) => {
        console.error('Erro ao carregar logs:', error);
      }
    );
  }

  getTipoLogDescricao(tipoLog: number): string {
    switch (tipoLog) {
      case 0:
        return 'Erro';
      case 1:
        return 'Sucesso';
      case 2:
        return 'Aviso';
      default:
        return 'Desconhecido';
    }
  }

  modalDetalhe(detalhe: string): void {
    this.dialog.open(InfoDialogComponent, {
      data: {
        titulo: 'Detalhes do Log',
        mensagem: detalhe
      }
    });
  }

  fecharDialog(): void {
    this.dialogRef.close();
  }

  maximizarDialog(): void {
    this.dialogRef.updateSize('100%', '100%');
    this.maximizado = true;
  }

  restaurarDialog(): void {
    let innerWidth = window.innerWidth;

    if (innerWidth < 1024) {
      this.dialogRef.updateSize('100%', '100vh');
    } else {
      this.dialogRef.updateSize('60%', '80vh');
    }

    this.maximizado = false;
  }
}
